import { CheckmarkCircle02Icon } from "@hugeicons-pro/core-stroke-standard";
import { HugeiconsIcon } from "@hugeicons/react";
import type { ReactElement } from "react";

interface PackageFeatureListProps {
  nodesFormatted: string;
}

export function PackageFeatureList({ nodesFormatted }: PackageFeatureListProps): ReactElement {
  const features = [
    {
      key: "node-credit",
      content: (
        <>
          رصيد لإضافة <strong className="font-bold">{nodesFormatted}</strong> فرد
        </>
      ),
    },
    { key: "tools", content: <>كل أدوات بناء الشجرة والوثائق </> },
    { key: "paper-tree-discount", content: <>خصم 15٪ على خدمة تصميم الشجرة الورقية</> },
    { key: "support", content: <>دعم فني </> },
  ];

  return (
    <ul className="mb-6 space-y-3 text-sm text-gray-600">
      {features.map((feature) => (
        <li key={feature.key} className="flex items-start gap-3">
          <HugeiconsIcon icon={CheckmarkCircle02Icon} size={14} className="text-green-600" strokeWidth={2.1} />
          <span>{feature.content}</span>
        </li>
      ))}
    </ul>
  );
}
